import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsUsageMessages = defineMessages("settings-usage", en);
